import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useContext, useEffect } from 'react';
import { usePermissions } from '@applyboard/business-ui-legacy';
import { Box } from '@applyboard/ui-components';
import { SimplifiedCheckEligibilityButton } from '@applyboard/dsj-ui';
import { ProgramSummary, AdmissionRequirements, DocumentRequirementTemplates, SimilarPrograms, LoginCard, Scholarships } from "../../components";
import { mobileBottomBorder, displayDesktopOnly, displayMobileOnly } from "../../consts";
import { AppContext } from "../../context";
import { useEventTracker } from '@applyboard/ui-utils';
export var LeftColumn = function LeftColumn(_ref) {
  var _resourceToPermission, _programData$schoolId;
  var currentUser = _ref.currentUser,
    children = _ref.children,
    eligibilities = _ref.eligibilities,
    openModal = _ref.openModal,
    pepRequirementExceptions = _ref.pepRequirementExceptions,
    pepRequirements = _ref.pepRequirements,
    program = _ref.program,
    programData = _ref.programData,
    programEnglishRequirementsExceptions = _ref.programEnglishRequirementsExceptions,
    programInitialProps = _ref.programInitialProps,
    programRequirements = _ref.programRequirements,
    schoolName = _ref.schoolName,
    sectionRefs = _ref.sectionRefs,
    scholarships = _ref.scholarships;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _usePermissions = usePermissions('entity_requirement', {
      enabled: !!(currentUser !== null && currentUser !== void 0 && currentUser.role)
    }),
    isLoadingPermissions = _usePermissions.isLoadingPermissions,
    resourceToPermissionsMapping = _usePermissions.resourceToPermissionsMapping;
  var canViewRequirements = (resourceToPermissionsMapping === null || resourceToPermissionsMapping === void 0 ? void 0 : (_resourceToPermission = resourceToPermissionsMapping.entity_requirement) === null || _resourceToPermission === void 0 ? void 0 : _resourceToPermission.includes('index')) || false;
  var _useContext = useContext(AppContext),
    hideEligibility = _useContext.hideEligibility,
    initialProps = _useContext.initialProps;
  var hasScholarships = scholarships.length > 0;
  useEffect(function () {
    trackEvent({
      event: 'Programs Page - Login to Explore More card displayed',
      data: {
        programId: programData === null || programData === void 0 ? void 0 : programData.id,
        programName: programData === null || programData === void 0 ? void 0 : programData.name
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: {
      xs: 2,
      md: 5
    },
    ref: sectionRefs.about,
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(ProgramSummary, {
    description: programData.description
  }), !currentUser && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    my: 5,
    px: 3,
    display: displayMobileOnly
  }, /*#__PURE__*/React.createElement(LoginCard, {
    vertical: true,
    program: programData
  })), /*#__PURE__*/React.createElement(Box, {
    my: 5,
    px: {
      xs: 3,
      md: 0
    },
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(LoginCard, {
    program: programData
  })))), children, /*#__PURE__*/React.createElement(Box, {
    ref: sectionRefs.requirements
  }, /*#__PURE__*/React.createElement(AdmissionRequirements, {
    programRequirements: programRequirements,
    delayedProofOfElpValue: programInitialProps.delayedProofOfElpEnum,
    programEnglishRequirementExceptions: programEnglishRequirementsExceptions,
    pepRequirements: pepRequirements,
    pepRequirementExceptions: pepRequirementExceptions,
    programLevel: programData.level,
    schoolName: schoolName,
    permissions: programInitialProps.permissions,
    loginAndRedirectUrl: programInitialProps.loginAndRedirectUrl,
    programId: programData.id
  })), !hideEligibility && initialProps && /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    px: {
      xs: 3,
      md: 0
    },
    pb: {
      xs: 5,
      md: 0
    },
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(SimplifiedCheckEligibilityButton, {
    eligibility: eligibilities,
    eventTrackingPrefix: "Programs Page",
    onClick: openModal,
    program: {
      id: programData.id,
      name: programData.name,
      programLevel: programData.level
    },
    school: {
      id: programData.schoolId,
      country: initialProps.country.name
    }
  })), /*#__PURE__*/React.createElement(Box, {
    mb: hasScholarships && 5,
    ref: sectionRefs.scholarships,
    px: {
      xs: 3,
      md: 0
    }
  }, hasScholarships && /*#__PURE__*/React.createElement(Scholarships, {
    scholarships: scholarships
  })), /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    ref: sectionRefs.programs,
    px: {
      xs: 3,
      md: 0
    }
  }, /*#__PURE__*/React.createElement(SimilarPrograms, {
    program: {
      id: programData.id,
      name: programData.name,
      schoolId: ((_programData$schoolId = programData.schoolId) === null || _programData$schoolId === void 0 ? void 0 : _programData$schoolId.toString()) || '',
      schoolName: schoolName || ''
    },
    searchUrl: programInitialProps.searchUrl
  })), /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, !isLoadingPermissions && canViewRequirements && /*#__PURE__*/React.createElement(DocumentRequirementTemplates, {
    program: program
  })));
};